import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import SfpBaseService from './sfp-base-service';

const PPI_INVESTMENT_THEMES = 'ppis/investments/themes';

export default class PPIInvestmentThemeService extends SfpBaseService {

  static createPPIInvestmentTheme(ppi_investment_theme) {
    const body = JSON.stringify({ppi_investment_theme});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${PPI_INVESTMENT_THEMES}`, {body, headers, method: "POST"})
      .then(super.returnResponse);
  }

  static updatePPIInvestmentTheme(ppi_investment_theme_id, ppi_investment_theme) {
    const body = JSON.stringify({ppi_investment_theme});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_investment_theme_id}/investment/theme`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
  }

  static deletePPIInvestmentTheme(ppi_investment_theme) {
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_investment_theme.id}/investment/theme`, {headers, method: "DELETE"})
      .then(super.returnResponse);
  }

}



// WEBPACK FOOTER //
// ./src/service/sfp/ppi-investment-theme-service.js